import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { ProfileAmlLevelInfo } from 'apps/auth/components/profile/aml/ProfileAmlLevelInfo';
import UsaCheckPersonalDetails from 'apps/auth/components/profile/aml/usa/UsaCheckPersonalDetails';
import UsaProfileAmlStandardLevelInfo from 'apps/auth/components/profile/aml/usa/UsaProfileAmlStandardLevelInfo';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AML_LEVEL_BASIC, AML_LEVEL_STANDARD } from 'apps/auth/constants/Constants';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

export const ProfileAmlLevelInfoPage = (props) => {
    const { countryId } = useAuth();
    const { profile_form: profile } = useExtra();
    const { profilePurpleBlock, notNowButton, nextButton, increase_sub_block, sourceOfIncome } = usePageMessages();
    const currentLimit = profile?.amlLimit?.currentLimit;

    useEffect(() => {
        if (countryId === USA) {
            amplitude.getInstance().logEvent('SSN ITIN Verification Screen Shown');
        }
    }, []);

    if (countryId === USA && UsaService.isNewLimits(profile)) {
        if (currentLimit === AML_LEVEL_BASIC) {
            return <UsaProfileAmlStandardLevelInfo toggleSpinner={props.toggleSpinner} />;
        } else if (currentLimit === AML_LEVEL_STANDARD) {
            return (
                <UsaCheckPersonalDetails
                    currentLevel={AML_LEVEL_STANDARD}
                    profilePurpleBlock={profilePurpleBlock}
                    personalDetailsBlock={sourceOfIncome}
                    increase_sub_block={increase_sub_block}
                    notNowButton={notNowButton}
                    nextButton={nextButton}
                />
            );
        }
    }
    return (
        <BaseLayout showChat={false}>
            <ProfileAmlLevelInfo />
        </BaseLayout>
    );
};
export default BasePage(ProfileAmlLevelInfoPage);
